import {
    noop,
} from 'lodash'
import {
    useCallback, useState,
} from 'react'
import {
    DateTimeValidationError,
} from '@mui/x-date-pickers'

const useDateInputError = ({
    name,
    setFormError = noop,
}: Readonly<{ name: string, setFormError?: (error: string[]) => void }>) => {
    const [
        isError,
        setIsError,
    ] = useState(false)

    const onError = useCallback((error: DateTimeValidationError) => {
        if (error) {
            setFormError([
                name,
                'Invalid date',
            ])
            setIsError(true)
        } else {
            setFormError([
                name,
                '',
            ])
            setIsError(false)
        }
    }, [
        name,
        setFormError,
    ])

    return {
        onError,
        isError,
    }
}

export default useDateInputError
